import { CSSObject } from '@emotion/react';
import { HoneycombThemeBase } from '../types';

export function focusStyles(theme: HoneycombThemeBase) {
    return (focusStyle?: CSSObject): CSSObject => ({
        WebkitTapHighlightColor: 'transparent',
        outline: 'none',
        '&:focus-visible': {
            ...(focusStyle || theme.focusRingStyles.styles(theme)),
        },
    });
}
